import { takeLatest, select, call, put } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
// import { OVERLAY_SPINNER, OVERLAY_TEXT } from "../../constants/overlayTypes";
import { PUSH_CREATE_ATTACHED_ITEM, PUSH_CREATE_DATA, PUSH_CREATE_FORM, PUSH_DATA, PUSH_DEFAULT } from "../../constants/state";
import getData from "../../functions/getData";
import { putSuccess, putError } from '../helpers'
import authUser from "../../apis/wpApi/authUser";
import { createPushCall } from "../../apis/wpApi/apiCalls";
import { OVERLAY_SPINNER } from "../../constants/overlayTypes";
import getBackgroundImage from "../../components/PageNewsletterTemplate/functions/getBackgroundImage";
import { AD, HIGHLIGHT, MOVIE, PUSH_LINK } from "../../constants/itemTypes";

function* overlaySetOverlayType(overlayType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: {overlayType: overlayType}})
}

function* overlaySetRequestType(requestType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: requestType }})
}

const getPushCreateData = state => ({
    form: getData(state, PUSH_CREATE_FORM),
    attachedItem: getData(state, PUSH_CREATE_ATTACHED_ITEM),
})

function* createPush(action) {
    try {


         yield call(overlaySetRequestType, actionTypes.PUSH_CREATE_REQUEST)
         yield call(overlaySetOverlayType, OVERLAY_SPINNER)

        const apiKey = yield call(authUser.getToken)
        const mode = action?.payload?.mode ? action.payload.mode : "Default"
        const {form, attachedItem} = yield select(getPushCreateData)
        const itemData = toDto(form, attachedItem, mode)
    
        if(!itemData) {
            throw new Error('No push data') 
        }

        const response = yield call(createPushCall, apiKey,  _.defaults(itemData, PUSH_DEFAULT))

        if(!response || !response.status || 200 !== response.status || !response.data) {
            throw new Error('Could not create push notification')
        } else {
            yield putSuccess(actionTypes.PUSH_CREATE_REQUEST_SUCCESS, {push: response.data, mode: mode})
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.PUSH_CREATE_REQUEST_ERROR, e.message)
    }
}

export function toDto(form, attachedItem, mode = "Default"){

    let dtoData = {
        ...form,
    }
    const normalizedUrl = dtoData?.link?.url && `${dtoData.link.url}`.trim().length > 0
        ? `${dtoData.link.url}`.trim()
        : null
    const normalizedLinkType = dtoData?.link?.destinationType === 'external' ? 'external' : 'internal'
    
    dtoData["cinemas"] = dtoData["cinemasFilter"] 
    dtoData["mode"] = mode
    dtoData["link"] = normalizedUrl ? {
        url: normalizedUrl,
        type: normalizedLinkType,
    } : null

    switch(attachedItem?.itemType){
        case MOVIE:{
            dtoData["imageUrl"] = getBackgroundImage(attachedItem?.item)?.imgUrl
            dtoData["iconUrl"] = attachedItem?.item?.images?.poster?.url
            dtoData["moviePk"] = attachedItem?.item?.id
            dtoData["link"] = null
            break
        }
        case AD:{
            const referencedMovie = attachedItem?.item?.referencedMovie || null
            dtoData["imageUrl"] = attachedItem?.item?.imageBackground?.url
                || attachedItem?.item?.imagePoster?.url
                || (referencedMovie ? getBackgroundImage(referencedMovie)?.imgUrl : null)
                || null
            dtoData["iconUrl"] = attachedItem?.item?.imagePoster?.url
                || referencedMovie?.images?.poster?.url
                || null
            dtoData["moviePk"] = attachedItem?.item?.movieRefID || referencedMovie?.id || null
            // keep dtoData.link for content pushes when URL is present
            break
        }
        case HIGHLIGHT:{
            const referencedMovie = attachedItem?.item?.referencedMovie || null
            dtoData["imageUrl"] = referencedMovie
                ? getBackgroundImage(referencedMovie)?.imgUrl
                : attachedItem?.item?.imageBackground?.url || attachedItem?.item?.imagePoster?.url || null
            dtoData["iconUrl"] = referencedMovie?.images?.poster?.url || attachedItem?.item?.imagePoster?.url || null
            dtoData["moviePk"] = referencedMovie?.id || attachedItem?.item?.movieRefID || null
            dtoData["link"] = null
            break
        }
        case PUSH_LINK:{
            dtoData["imageUrl"] = null
            dtoData["iconUrl"] = null
            dtoData["moviePk"] = null
            // dtoData.link is already set above
            break
        }
        default:{
            dtoData["imageUrl"] = null
            dtoData["iconUrl"] = null
            dtoData["moviePk"] = null
            dtoData["link"] = null
        }
    }
    
    return dtoData
}

function* watchPushCreateRequest() {
    yield takeLatest(actionTypes.PUSH_CREATE_REQUEST, createPush);
}

export default watchPushCreateRequest
